module.exports = __webpack_public_path__ + "static/media/item_2_2ll.2684d910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_2ll.png
// module id = 119
// module chunks = 0